import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDirecteExpenseLedgerApi } from "../../apiservice/reports";
import { getAccountBySeachApi } from "../../apiservice/setting";
import { currentDateEndTime, currentDateStartTime } from "../../lib/functions";

export const fetchDirectExpenseLedger = createAsyncThunk(
  "directExpenseLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getDirecteExpenseLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchDirectExpenseAccountsBySearch = createAsyncThunk(
  "directExpenseLedger/fetchAccountsBySearch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({        
        multiType: ["direct_expense"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
